import axios from "axios";
// import { useSelector } from "react-redux"; // Import the useSelector hook

const API = axios.create({
    baseURL: "https://api.seamlesspay.global",
    // baseURL: "http://localhost:8000",
});

export default API;
